/**
 * Checks to see if the current element is visible in another element (defaults to window)
 */
var _ = require('underscore');

module.exports = function($) {

    $.fn.swIsInBlockView = function(options) {
        options = _.defaults(options || {}, {

            /**
             * $el is the "view" element. Defaults to window
             */
            $el: $(window),

            /**
             * bufferDistance makes the element count as in view sooner if positive
             * and later if negative. In other words buffer distance can be thought of "expanding"
             * the view if positive and contracting it if negative.
             */
            bufferDistance: 0
        });

        var $this = $(this);
        var docViewTop = options.$el.scrollTop();
        var docViewBottom = docViewTop + options.$el.height();
        var topBoundry = $this.offset().top + options.bufferDistance;
        var bottomBoundry = $this.offset().top + $this.height() - options.bufferDistance;
        return {
            bottomIsIn:  (bottomBoundry <= docViewBottom),
            topIsIn: (topBoundry >= docViewTop)
        };
    };

};
